import React, { useState, useEffect } from 'react';
import StackGrid, { transitions, easings } from 'react-stack-grid';
import { showPopup } from '../../complex/popupWithSlider/popupWithSlider';
import sizeMe from 'react-sizeme';

import './_imageGrid.scss';

const { scaleUp, scaleDown } = transitions;

const { cubicOut } = easings;
// const text = () => {
//   return {
//     __html: `<p>The concert dedicated to the music of Giya Kancheli</p>
// <p>Armenian State Symphony Orchestra</p>
// <p><strong>Violin</strong>:&nbsp;Andrea Cortesi</p>
// <p><strong>Viola:&nbsp;</strong>Giorgi Zagareli</p>
// <p><strong>Conductor:&nbsp;</strong>Sergey Smbatyan</p>`,
//   };
// };

function ImageGrid (props) {
  const [grid, setGrid] = useState(null);
  const [dimensions, setDimensions] = useState({});
  const width = window.innerWidth;
  useEffect(() => {
    grid !== null && grid.updateLayout();
    props.swiper !== null && props.swiper.update();
  }, [props.src, grid, width, props.mediaUrl, props.swiper]);

  function onImgLoad ({ target: img }) {
    grid !== null && grid.updateLayout();
    setDimensions({
      height: img.offsetHeight,
      width: img.offsetWidth,
    });
  }

  function slideTo (className, index) {
    showPopup(className);
    props.swiper !== null && props.swiper.slideTo(index, 0, false);
  }

  // function getThumbFromUrl(url) {
  //     let VID_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  //
  //     return (
  //         `https://img.youtube.com/vi/${url.match(VID_REGEX)[1]}/mqdefault.jpg`
  //     )
  // }

  return (
    <div>
      <StackGrid
        // appearDelay={30}
        columnWidth={width < 768 ? '100%' : '33.33%'}
        className='grid-container'
        duration={600}
        easing={cubicOut}
        gutterWidth={15}
        gutterHeight={15}
        appear={scaleUp.appear}
        appeared={scaleDown.appeared}
        enter={scaleUp.enter}
        leaved={scaleDown.leaved}
        entered={scaleDown.entered}
        gridRef={(grid) => setGrid(grid)}
      >
        {props.src.map((item, i) => {
          return (
            <div
              key={`key${i}`}
              className='press-inner-grid'
              onClick={() => slideTo('.press-inner', i)}
            >
              <div className='press-inner-info'>
                <div>
                  <div className='press-inner-info-block'>
                    <h6 className='press-inner-info-title'>{item.title}</h6>
                    <div
                      dangerouslySetInnerHTML={{ __html: item.description }}
                      className='press-inner-info-desc'
                    />
                  </div>
                  {item.type === 'image' && (
                    <div className='press-inner-dwnld'>
                      <a href={item.image} download>
                        <img
                          src='/media/icons/inclassica/Icon-download.svg'
                          alt=''
                        />
                      </a>
                    </div>
                  )}
                </div>
              </div>
              <div className='press-inner-info-img'>
                {item.type === 'image' && (
                  <img src={item.image} alt='' onLoad={onImgLoad} />
                )}
                {item.type === 'video' && (
                  <>
                    <img
                      src='/media/icons/inclassica/icon-play.svg'
                      alt='play icon'
                      className='press-inner-info-play'
                    />
                    <img
                      src={item.thumbnail}
                      alt='img thumbnail'
                      onLoad={onImgLoad}
                    />
                  </>
                )}
              </div>
            </div>
          );
        })}
      </StackGrid>
    </div>
  );
}

export default sizeMe()(ImageGrid);
